import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'rlst-locate-on-map',
  templateUrl: './locate-on-map.component.html',
  styleUrls: ['./locate-on-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocateOnMapComponent {
  public locateOnMapForm: UntypedFormGroup;
  public options: Array<string> = [];

  constructor(private readonly fb: UntypedFormBuilder) {
    this.locateOnMapForm = this.fb.group({
      myControl: ['']
    });
  }

}
